/*eslint max-statements-per-line: ["error", { "max": 2 }]*/

import React from "react";
// Limitless imports
import { log as pilog, mfaReloadPage, mfaFreezeVerification } from "@limitless/common/utils";
import { verifyPhoneAttribute, verifyMFALoginCode, sendSMSVerificationCode, signOutUser, updatePhoneAttribute, refreshToken } from "../../../expert/apis/authentication-api/AuthenticationAPI";
import { useSignInContext } from "@limitless/expert";
import { updateMobileAppStorage } from "@limitless/portal";
import { useExpertProfileContext } from "../../../expert/hooks/expert-profile/ExpertProfileContext";
import { useLoginWrapperContext } from "../../../expert";
import { isNumeric } from "@limitless/portal/utils";
import { useAuthenticationContext } from "@limitless/expert";
import { MFA_INVALID_CODE_PROVIDED, MFA_EXPIRY_CODE_PROVIDED, MFA_LIMIT_EXCEED, MFA_INVALID_PHONE_NUMBER_PROVIDED } from "@limitless/portal";
import { getPhoneNumberInInternationalFormat, getParseMfaPhoneNumber } from "../../utils";
import { useAppConfig } from "@limitless/common/hooks";
export const getInitialMfaState = (dialCodes, profile, screen, mfaLoginState, isEmailVerifyed = false) => {
  var _dialCodes$find, _mfaLoginState$challe, _profile$_phoneDetail;
  const country = profile.country || "GB";
  let dialCode = ((_dialCodes$find = dialCodes.find(dc => dc.countryCode === country)) === null || _dialCodes$find === void 0 ? void 0 : _dialCodes$find.dialCode) || 44;
  dialCode = `+${dialCode}`;
  const phoneNumber = ((_mfaLoginState$challe = mfaLoginState.challengeParameters) === null || _mfaLoginState$challe === void 0 ? void 0 : _mfaLoginState$challe.CODE_DELIVERY_DESTINATION) || getPhoneNumberInInternationalFormat(profile.primaryContactNumber) || (profile === null || profile === void 0 ? void 0 : (_profile$_phoneDetail = profile._phoneDetails) === null || _profile$_phoneDetail === void 0 ? void 0 : _profile$_phoneDetail.phoneNumber) || dialCode;
  return {
    dialCode,
    errTxt: null,
    mfaType: "SMS",
    loading: false,
    // submitPhoneScreen: mfaLoginState.isPhoneNumberVerify,
    submitPhoneScreen: screen === "mfaVerify" || screen === "mfaVerifyScreen" ? false : true,
    code: null,
    phoneNumber,
    mfaStepIndex: 0,
    isEmailVerifyed: isEmailVerifyed,
    editPhoneScreen: true
  };
};
const MAX_CODE_LENGTH = 6;
const SHOW_RESEND_AFTER = 30000;
const INITIAL_STATE = {
  loading: false,
  code: null,
  errTxt: null,
  btnVisible: false,
  verifyFailed: false,
  freezeVerification: false,
  checkDeviceForMFACode: false,
  isChangeNumber: false
};
const confirmMFACode = (type, code) => {
  let confirmMFACodeMethod;
  // type :: SMS / TOTP
  switch (type) {
    case "TOTP":
      confirmMFACodeMethod = () => {
        throw new Error("TOTP code verification not implemented");
      };
      break;
    default:
      confirmMFACodeMethod = () => verifyPhoneAttribute(code);
  }
  return new Promise((resolve, reject) => {
    confirmMFACodeMethod().then(mfaVerifiyResponse => {
      resolve(mfaVerifiyResponse);
    }).catch(err => reject(err));
  });
};
const resendMFACode = type => {
  let confirmMFACodeMethod;
  // type :: SMS / TOTP
  switch (type) {
    case "TOTP":
      confirmMFACodeMethod = () => {
        throw new Error("TOTP code resend not implemented");
      };
      break;
    default:
      confirmMFACodeMethod = () => sendSMSVerificationCode();
  }
  return new Promise((resolve, reject) => {
    confirmMFACodeMethod().then(mfaResendCodeResponse => {
      resolve(mfaResendCodeResponse);
    }).catch(err => reject(err));
  });
};
export const useMFAVerify = () => {
  const log = pilog.getLogger("MFAVerifyHook useMFAVerify");
  const [mfaCtx, setMfaCtx] = React.useState(null);
  const [verifyMFAState, setVerifyMFAState] = React.useState(INITIAL_STATE);
  const [clearCodes, setClearCodes] = React.useState(false);
  const {
    mfaLoginState,
    mfaVerifyScreenSuccessCB,
    mfaCogntioChallengePass
  } = useLoginWrapperContext();
  const {
    setUserAsAuthenticated
  } = useAuthenticationContext();
  const {
    postAuthenticationActions
  } = useSignInContext();
  const {
    saveProfile,
    senEmailOtp
  } = useExpertProfileContext();
  const {
    config: {
      dialCodes
    }
  } = useAppConfig();
  const modifyErrorTxt = err => {
    let errTxt = err.message || err;
    let modify = true;
    if ((err === null || err === void 0 ? void 0 : err.code) === "CodeMismatchException") {
      errTxt = MFA_INVALID_CODE_PROVIDED;
    } else if ((err === null || err === void 0 ? void 0 : err.code) === "InvalidParameterException") {
      errTxt = MFA_INVALID_PHONE_NUMBER_PROVIDED;
    } else if ((err === null || err === void 0 ? void 0 : err.code) === "ExpiredCodeException") {
      errTxt = MFA_EXPIRY_CODE_PROVIDED;
    } else if ((err === null || err === void 0 ? void 0 : err.code) === "LimitExceededException" || (err === null || err === void 0 ? void 0 : err.code) === "NotAuthorizedException") {
      errTxt = MFA_LIMIT_EXCEED;
    } else {
      modify = false;
    }
    return {
      errTxt,
      modify
    };
  };
  const updateStateAfterError = (err, stateObj) => {
    const invalidCodeResponse = modifyErrorTxt(err);
    if (invalidCodeResponse.modify) {
      stateObj.errTxt = invalidCodeResponse.errTxt;
    }
    if (mfaReloadPage(err)) {
      stateObj.reload = true;
      stateObj.errTxt = null;
    }
    if (mfaFreezeVerification(err)) {
      stateObj.freezeVerification = true;
    }
    setVerifyMFAState(stateObj);
  };
  const verifyButtonHandler = async ({
    type,
    notificationHeader = "",
    primaryContactNumber = "",
    mfaState = {}
  }, successCB) => {
    log.debug(`verifyButtonHandler: type: ${type} code: ${verifyMFAState.code}`);
    setVerifyMFAState({
      ...INITIAL_STATE,
      isChangeNumber: verifyMFAState.isChangeNumber,
      loading: true
    });
    try {
      if (mfaLoginState.challengeParameters) {
        async function fetchRefreshToken() {
          await refreshToken().then(data => {
            postAuthenticationActions(data.idToken);
            setUserAsAuthenticated();
            mfaCogntioChallengePass();
          });
        }
        log.trace("into mfa login");
        verifyMFALoginCode(verifyMFAState.code, () => {
          fetchRefreshToken();
        }, error => {
          const stateObj = {
            ...INITIAL_STATE,
            verifyFailed: true,
            loading: false,
            errTxt: (error === null || error === void 0 ? void 0 : error.message) || error,
            checkDeviceForMFACode: false,
            isChangeNumber: verifyMFAState.isChangeNumber
          };
          updateStateAfterError(error, stateObj);
        });
      } else {
        log.trace("into mfa setup");
        await confirmMFACode(type, verifyMFAState.code);
        await refreshToken().then(data => {
          postAuthenticationActions(data.idToken);
          setUserAsAuthenticated();
          if (process.env.REACT_APP_TYPE === "mobile") {
            window.localStorage = localStorage;
            const mobileAppTokenKey = `@MemoryStorage:CognitoIdentityServiceProvider.${process.env.REACT_APP_CLIENT_ID}.${data.idToken.payload["cognito:username"]}.idToken`;
            localStorage.setItem(`@MemoryStorage:CognitoIdentityServiceProvider.${process.env.REACT_APP_CLIENT_ID}.LastAuthUser`, data.idToken.payload["cognito:username"]);
            localStorage.setItem(mobileAppTokenKey, data.idToken.jwtToken, () => {
              updateMobileAppStorage(() => localStorage.getItem(mobileAppTokenKey));
            });
          }
        }).catch(e => {
          log.warn("Unauthorised %o", e);
        });
        // if otp is verified the redirect it to the

        mfaVerifyScreenSuccessCB();
        successCB();
        if (mfaState.mfaStepIndex !== 0) {
          setClearCodes(true);
          setVerifyMFAState({
            ...INITIAL_STATE,
            verifyFailed: false,
            loading: false,
            isChangeNumber: verifyMFAState.isChangeNumber,
            editPhoneScreen: true
          });
          if (typeof successCB === "function") {
            successCB();
          }
        }
      }
    } catch (err) {
      const errTxt = (err === null || err === void 0 ? void 0 : err.message) || err;
      log.error("confirmMFACode Err:", err);
      const stateObj = {
        ...INITIAL_STATE,
        verifyFailed: true,
        loading: false,
        errTxt,
        checkDeviceForMFACode: false,
        isChangeNumber: verifyMFAState.isChangeNumber
      };
      updateStateAfterError(err, stateObj);
    }
  };
  const resendButtonHandler = ({
    type
  }) => async () => {
    log.debug(`resendButtonHandler type: ${type}`);
    setVerifyMFAState({
      ...INITIAL_STATE,
      loading: true,
      isChangeNumber: verifyMFAState.isChangeNumber
    });
    setClearCodes(false);
    try {
      await resendMFACode(type);
      setClearCodes(true);
      setVerifyMFAState({
        ...INITIAL_STATE,
        checkDeviceForMFACode: true,
        isChangeNumber: verifyMFAState.isChangeNumber
      });
    } catch (err) {
      const errTxt = (err === null || err === void 0 ? void 0 : err.message) || err;
      log.error("resendButtonHandler Err:", err);
      const stateObj = {
        ...verifyMFAState,
        verifyFailed: true,
        errTxt,
        checkDeviceForMFACode: false,
        freezeVerification: false
      };
      updateStateAfterError(err, stateObj);
    } finally {
      const timeOut = setTimeout(() => {
        if (!verifyMFAState.freezeVerification) {
          setVerifyMFAState({
            ...verifyMFAState,
            errTxt: null,
            checkDeviceForMFACode: false
          });
        }
        clearTimeout(timeOut);
      }, SHOW_RESEND_AFTER);
    }
  };
  const updateCodeCollector = code => {
    setClearCodes(false);
    if (code.length === MAX_CODE_LENGTH && isNumeric(code) && !verifyMFAState.freezeVerification) {
      setVerifyMFAState({
        ...INITIAL_STATE,
        btnVisible: true,
        code,
        isChangeNumber: verifyMFAState.isChangeNumber
      });
    } else {
      setVerifyMFAState({
        ...INITIAL_STATE,
        isChangeNumber: verifyMFAState.isChangeNumber
      });
    }
  };
  const updateEmailCodeCollector = code => {
    setClearCodes(false);
    if (code.length === 4 && isNumeric(code) && !verifyMFAState.freezeVerification) {
      setVerifyMFAState({
        ...INITIAL_STATE,
        btnVisible: true,
        code,
        isChangeNumber: verifyMFAState.isChangeNumber
      });
    } else {
      setVerifyMFAState({
        ...INITIAL_STATE,
        isChangeNumber: verifyMFAState.isChangeNumber
      });
    }
  };
  const setReload = (reload = true) => setVerifyMFAState({
    ...INITIAL_STATE,
    reload,
    isChangeNumber: verifyMFAState.isChangeNumber
  });
  const backToLogin = (userName, navigateCB) => {
    signOutUser(userName);
    if (typeof navigateCB === "function") {
      navigateCB();
    } else {
      window.location.reload();
    }
  };
  const validateMfaSMS = async (mfaState, callback, isChangeNumber = false) => {
    const parsePhoneNumber = getParseMfaPhoneNumber(mfaState.phoneNumber, dialCodes);
    try {
      callback({
        ...mfaState,
        loading: false,
        submitPhoneScreen: !mfaState.submitPhoneScreen,
        editPhoneScreen: false,
        phoneNumber: parsePhoneNumber
      });
      await updatePhoneAttribute(parsePhoneNumber);
      await sendSMSVerificationCode();
      const updateProfile = {
        ...(mfaState.mfaStepIndex !== 1 && {
          primaryContactNumber: parsePhoneNumber
        })
      };
      setVerifyMFAState({
        ...INITIAL_STATE,
        isChangeNumber
      });
      callback({
        ...mfaState,
        loading: false,
        submitPhoneScreen: !mfaState.submitPhoneScreen,
        editPhoneScreen: true,
        phoneNumber: parsePhoneNumber
      });
    } catch (err) {
      const {
        errTxt
      } = modifyErrorTxt(err);
      let stateObj;
      if (mfaReloadPage(err)) {
        setReload();
        stateObj = {
          ...mfaState,
          loading: false
        };
      } else {
        stateObj = {
          ...mfaState,
          loading: false,
          errTxt: `${errTxt}`
        };
      }
      if (typeof callback === "function") {
        callback(stateObj);
      }
    }
  };
  const clearCode = () => {
    setClearCodes(true);
  };
  const validateMfaEmail = async (phoneNumberChangeVerificationCode, mfaState, callback, isChangeNumber = false) => {
    const parsePhoneNumber = getParseMfaPhoneNumber(mfaState.phoneNumber, dialCodes);
    setVerifyMFAState({
      ...INITIAL_STATE,
      isChangeNumber
    });
    await senEmailOtp(phoneNumberChangeVerificationCode ? phoneNumberChangeVerificationCode : null, data => {
      if (data.hasError) {
        var _data$error$graphQLEr, _data$error, _data$error$graphQLEr2;
        const {
          errorInfo
        } = (_data$error$graphQLEr = (_data$error = data.error) === null || _data$error === void 0 ? void 0 : (_data$error$graphQLEr2 = _data$error.graphQLErrors) === null || _data$error$graphQLEr2 === void 0 ? void 0 : _data$error$graphQLEr2[0]) !== null && _data$error$graphQLEr !== void 0 ? _data$error$graphQLEr : {};
        console.log(errorInfo, "errorInfo");
        let stateObj;
        if (mfaReloadPage(data.error)) {
          setReload();
          stateObj = {
            ...mfaState,
            loading: false
          };
        } else {
          stateObj = {
            ...mfaState,
            loading: false,
            errTxt: errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.message
          };
        }
        if (typeof callback === "function") {
          callback(stateObj);
        }
      } else {
        callback({
          ...mfaState,
          errTxt: "",
          loading: false,
          submitPhoneScreen: !mfaState.submitPhoneScreen,
          editPhoneScreen: false,
          isEmailVerifyed: phoneNumberChangeVerificationCode ? true : false,
          mfaStepIndex: mfaState.mfaStepIndex >= 2 ? 1 : mfaState.mfaStepIndex + 1,
          phoneNumber: mfaState.dialCode
        });
      }
    });
  };
  const submitPhoneNumber = async (mfaState, callback, isChangeNumber = false) => {
    const parsePhoneNumber = getParseMfaPhoneNumber(mfaState.phoneNumber, dialCodes);
    try {
      await updatePhoneAttribute(parsePhoneNumber);
      await sendSMSVerificationCode();
      const updateProfile = {
        ...(mfaState.mfaStepIndex !== 1 && !isChangeNumber && {
          primaryContactNumber: parsePhoneNumber
        })
      };
      // For EMA MFA Conditional routing and security screen
      setVerifyMFAState({
        ...INITIAL_STATE,
        isChangeNumber
      });
      if (mfaState.mfaStepIndex !== 0 && !isChangeNumber) {
        saveProfile(updateProfile, () => {
          if (typeof callback === "function") {
            callback({
              ...mfaState,
              loading: false,
              submitPhoneScreen: !mfaState.submitPhoneScreen,
              phoneNumber: parsePhoneNumber,
              editPhoneScreen: false
            });
          }
        }, "Update Profile", false);
      }
    } catch (err) {
      const {
        errTxt
      } = modifyErrorTxt(err);
      let stateObj;
      if (mfaReloadPage(err)) {
        setReload();
        stateObj = {
          ...mfaState,
          loading: false
        };
      } else {
        stateObj = {
          ...mfaState,
          loading: false,
          errTxt: `${errTxt}`
        };
      }
      if (typeof callback === "function") {
        callback(stateObj);
      }
    }
  };
  return {
    maxLength: MAX_CODE_LENGTH,
    clearCodes,
    verifyMFAState,
    mfaCtx,
    setMfaCtx,
    setReload,
    backToLogin,
    verifyButtonHandler,
    resendButtonHandler,
    validateMfaEmail,
    clearCode,
    updateCodeCollector,
    updateEmailCodeCollector,
    submitPhoneNumber,
    validateMfaSMS
  };
};